<div class="center">
  <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
</div>

<p-dialog #serviceAgreement id="service-agreement"
  [header]="serviceAgreementHeader"
  [visible]="showServiceAgreement"
  (visibleChange)="logmeout()"
  modal="modal"
  baseZIndex="1"
  height="600"
  width="970">

  <span class="ui-confirmdialog-message" [innerHTML]="serviceAgreementBodyContent"></span>
  <ng-template pTemplate="footer">
    <div class="ps-3 pt-2 pb-2">
      <button id="sa-yes" type="button" class="btn btn-default width-100px" (click)="accept()">Yes</button>
      <span style="margin-left: 1.5em;"></span>
      <button id="sa-no" type="button" class="btn btn-secondary width-100px" (click)="logmeout()">No</button>
      <span style="margin-left: 3em;"></span>
    </div>
  </ng-template>
</p-dialog>